import type { Theme } from "@/context/theme";

export const THEME_TOGGLE_OPTIONS: readonly {
  value: Theme;
  labelKey: string;
  icon: string;
}[] = [
  { value: "light", labelKey: "themeoption.light", icon: "lucide:sun" },
  { value: "dark", labelKey: "themeoption.dark", icon: "lucide:moon" },
  { value: "system", labelKey: "themeoption.system", icon: "lucide:monitor" },
];
